import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultButtons = _resolveComponent("DefaultButtons")!
  const _component_OutlineButtons = _resolveComponent("OutlineButtons")!
  const _component_SoftButtons = _resolveComponent("SoftButtons")!
  const _component_ButtonsWithIcon = _resolveComponent("ButtonsWithIcon")!
  const _component_RoundedButtons = _resolveComponent("RoundedButtons")!
  const _component_OutlineRoundedButtons = _resolveComponent("OutlineRoundedButtons")!
  const _component_BlockButtons = _resolveComponent("BlockButtons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DefaultButtons)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_OutlineButtons)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SoftButtons)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ButtonsWithIcon)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_RoundedButtons)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_OutlineRoundedButtons)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_BlockButtons)
    ])
  ]))
}